module.exports = "/_next/static/images/cart_alt-dadf0a7c5e7fcd0a6f8e18d46ad9c73e.svg";